/**
 * Created by stonewang on 2020/12/05.
 */
import {config, request} from 'Utils';

export function addQuotation(param) {
  return request(`${config.server}/api/v1/dms/offer/add`, {
    method: 'post',
    body: param
  });
}
/** 报价单编辑*/
export function updateQuotation(param) {
  return request(`${config.server}/api/v1/dms/offer/update`, {
    method: 'post',
    body: param
  });
}
/** 报价单列表*/
export function listQuotation(param) {
  return request(`${config.server}/api/v1/dms/offer/pageList`, {
    method: 'post',
    body: param
  });
}
/*报价单批量删除
 * param:
 *
 * {
    "ids":[10]  // 报价单id集合
}
 *
 * */
export function batchDelete(param) {
  return request(`${config.server}/api/v1/dms/offer/batchDelete`, {
    method: 'post',
    body: param
  });
}

/** 报价单详情*/
export function quotationDetail(id) {
  return request(`${config.server}/api/v1/dms/offer/detail`, {
    method: 'get',
    body: {
      id
    }
  });
}
/** 报价单-详情-下载 */
export function downWord(id) {
  return request(`${config.server}/api/v1/dms/offer/downWord`, {
    method: 'get',
    body: {
      id
    }
  });
}



// WEBPACK FOOTER //
// ./src/service/quotation/index.js